import React, { useState, useEffect } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import axios from "axios";
import { Loader, Dimmer } from "semantic-ui-react";
import { ActualizarAfiliados } from "./modalActualizarAfiliados";
import useTable from "../useTable";
import { Mensaje } from "../mensajes";

function TablaAfiliados(props) {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const idorganizacion = JSON.parse(sessionStorage.getItem("idorganizacion"));

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CODIGO",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "NOMBRES/RAZON SOCIAL",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "RIF",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const [mostrarAfiliado, setMostrarAfiliado] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [organizacion, setOrganizacion] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idorganizacion.includes(target.value) ||
              x.nombre.toUpperCase().includes(target.value.toUpperCase()) ||
              x.rif.toUpperCase().includes(target.value.toUpperCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    setActivate(true);
    let campos = "*";
    let nomtab = "organizacion";
    let nomid = "idorganizacion";
    let orden = "idorganizacion";
    let endpoint = "";

    if (props.menu === "sistema") {
      endpoint = `${op.conexion}/api/athos/consulta/seleccionarregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    }
    if (props.menu === "organizacion") {
      endpoint = `${op.conexion}/api/athos/consulta/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idorganizacion}`;
    }

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          } else {
            setRecords([]);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto:
            error.response === undefined
              ? "Error de Conexion"
              : error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarRegistro = (id) => {
    setActivate(true);
    let campos = "*";
    let nomtab = "organizacion";
    let nomid = "idorganizacion";
    let endpoint = `${op.conexion}/api/athos/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setOrganizacion(response.data);
          setMostrarAfiliado(true);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto:
            error.response === undefined
              ? "Error de Conexion"
              : error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const gestionarOrganizacion = (id, ope) => (event) => {
    event.preventDefault();
    setOperacion(ope);
    if (ope === 1) {
      setMostrarAfiliado(true);
    } else if (ope === 2) {
      seleccionarRegistro(id);
    } else if (ope === 3) {
      seleccionarRegistro(id);
    } else if (ope === 4) {
      seleccionarRegistro(id);
    }
  };

  useEffect(() => {
    seleccionarRegistros();
  }, []);

  return (
    <div className="container-fluid rounded">
      <div className="container-fluid">
        <div className="card">
          <Dimmer active={activate} inverted>
            <Loader inverted>cargando...</Loader>
          </Dimmer>

          <div className="container">
            <div className="content">
              <div className="container">
                <div className="col-md-12 row m-0 py-2">
                  <div className="col-md-2">
                    <input
                      type="text"
                      className="form-control form-control-sm rounded-pill"
                      onChange={handleSearch}
                      placeholder="Buscar"
                    />
                  </div>

                  {props.menu === "sistema" && (
                    <div className="col-md-1 ml-auto">
                      <button
                        onClick={gestionarOrganizacion("", 1)}
                        className="btn btn-sm btn-primary rounded-circle"
                      >
                        <i className="fas fa-plus"></i>{" "}
                      </button>
                    </div>
                  )}
                </div>
                <div className="col-md-12">
                  <TblContainer>
                    <TblHead />

                    <TableBody>
                      {records &&
                        recordsAfterPagingAndSorting().map((item, index) => (
                          <TableRow key={index} style={{ padding: "0" }}>
                            <TableCell
                              className="align-baseline"
                              style={{ textAlign: "center", width: "50px" }}
                            >
                              {item.idorganizacion}
                            </TableCell>
                            <TableCell
                              className="align-baseline"
                              style={{ textAlign: "start", width: "250px" }}
                            >
                              {item.nombre}
                            </TableCell>
                            <TableCell
                              className="align-baseline"
                              style={{ textAlign: "center", width: "250px" }}
                            >
                              {item.rif}
                            </TableCell>
                            <TableCell
                              className="align-baseline"
                              style={{ textAlign: "center", width: "100px" }}
                            >
                              <button
                                onClick={gestionarOrganizacion(
                                  item.idorganizacion,
                                  4
                                )}
                                className="btn btn-sm  btn-info rounded-circle ml-2"
                              >
                                <i className="fas fa-eye"></i>{" "}
                              </button>
                              <button
                                onClick={gestionarOrganizacion(
                                  item.idorganizacion,
                                  2
                                )}
                                className="btn btn-sm  btn-warning rounded-circle ml-2"
                              >
                                <i className="fa fa-edit"></i>{" "}
                              </button>
                              {props.menu === "sistema" && (
                                <button
                                  onClick={gestionarOrganizacion(
                                    item.idorganizacion,
                                    3
                                  )}
                                  className="btn btn-sm  btn-danger rounded-circle ml-2"
                                >
                                  <i className="fa fa-trash"></i>{" "}
                                </button>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </div>
              </div>
            </div>
          </div>
          <Mensaje
            mensaje={mensaje}
            onHide={() => {
              setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
            }}
          />
          <ActualizarAfiliados
            show={mostrarAfiliado}
            operacion={operacion}
            menu={props.menu}
            organizacion={organizacion}
            onHideCancela={() => setMostrarAfiliado(false)}
            onHideAcepta={seleccionarRegistros}
          />
        </div>
      </div>
    </div>
  );
}

export default TablaAfiliados;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/tablaAfiliados.js